import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';

const GallerySection = ({ spaceData }) => {
  const imagesArray = (() => {
    try {
      const parsed =
        spaceData?.url_img && spaceData?.url_img !== null
          ? JSON.parse(spaceData?.url_img)
          : JSON.parse(spaceData?.main_image);

      return Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [spaceData?.main_image].filter(Boolean);
    } catch {
      return [spaceData?.main_image].filter(Boolean);
    }
  })();

  const firstImage = imagesArray[0];

  return (
    <FlexContainer className="height-420px border-rad12px overflow-hidden width100">
      {firstImage && (
        <img
          className="width100 height100 objectCover block"
          src={firstImage}
          alt={spaceData?.space_title || 'space'}
        />
      )}
    </FlexContainer>
  );
};

export default GallerySection;
